import React from 'react';
import Header from '../components/Header';
import './LandingLayout.scss';

interface LandingLayoutProps {
  children: React.ReactNode;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  return (
    <div className="landing-layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default LandingLayout;
